export default "<p>\n  footer works!\n</p>\n";